import { render, staticRenderFns } from "./jjfatop.vue?vue&type=template&id=1e702852&scoped=true&"
import script from "./jjfatop.vue?vue&type=script&lang=js&"
export * from "./jjfatop.vue?vue&type=script&lang=js&"
import style0 from "./jjfatop.vue?vue&type=style&index=0&id=1e702852&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e702852",
  null
  
)

export default component.exports